<template>
  <v-container fluid align-content-center justify-start class="loginOverlay">
    <v-layout wrap align-center justify-center>
<!--      <v-alert class="mt-1 mb-4"-->
<!--               :value="true"-->
<!--               color="error"-->
<!--               type="error"-->
<!--               outline-->
<!--      >-->
<!--        <span>ขณะนี้ระบบปิดปรับปรุงชั่วคราว กรุณาใช้ผ่านระบบพัสดุ CMIS</span>-->
<!--      </v-alert>-->
      <v-flex xs12 sm12 md12 style="text-align: center" class="mt-3">
        <img src="../assets/img/logo/350x350.png" style="width: 180px" alt=""/>
      </v-flex>
      <div class="flex xs12 md12 sm12">
        <h1 class="mt-3 text-center display-1 font-weight-bold">พัสดุ</h1>
      </div>
      <v-flex xs12 sm4 md4 class="mt-4">
        <v-card class="card-border">
          <v-card-text class="pt-2">
            <div>
              <v-alert v-if="error.status==='0'" class="mt-1 mb-4"
                       :value="true"
                       color="error"
                       type="error"
                       outline
              >
                <span>{{ error.msg }}</span>
              </v-alert>

              <v-form v-model="valid" ref="form">
                <!--<p class="blue-grey--text font-weight-bold">ชื่อผู้ใช้งาน</p>-->
                <v-text-field
                  label="ชื่อผู้ใช้งาน"
                  v-model="user_data.username"
                  :rules="usernameRules"
                  required
                  placeholder="Username"
                  @keypress.enter="loginUser()"
                ></v-text-field>

                <!--<p class="blue-grey--text font-weight-bold">รหัสผ่าน</p>-->
                <v-text-field
                  label="รหัสผ่าน"
                  v-model="user_data.password"
                  :append-icon="e1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="e1 ? 'text' : 'password'"
                  @click:append="e1 = !e1"
                  :rules="passwordRules"
                  required
                  placeholder="Password"
                  @keypress.enter="loginUser()"
                ></v-text-field>
<!--                <v-text-field-->
<!--                  label="รหัสผ่าน"-->
<!--                  v-model="user_data.password"-->
<!--                  :append-icon="e1 ? 'mdi-eye' : 'mdi-eye-off'"-->
<!--                  :type="e1 ? 'text' : 'password'"-->
<!--                  @click:append="e1 = !e1"-->
<!--                  :rules="passwordRules"-->
<!--                  required-->
<!--                  placeholder="Password"-->
<!--                ></v-text-field>-->
                <v-layout justify-space-between class="mt-2">
                  <v-btn @click="loginUser"
                         :class="valid ? 'blue darken-4 white--text':'grey white--text'"
                         :disabled="!valid">ล๊อคอิน
                  </v-btn>
<!--                  <v-btn :class="valid ? 'blue darken-4 white&#45;&#45;text':'grey white&#45;&#45;text'"-->
<!--                         :disabled="!valid">ล๊อคอิน-->
<!--                  </v-btn>-->
                  <a href="https://selfservice.lpn.co.th:8888">ลืมรหัสผ่าน?</a>
                </v-layout>
              </v-form>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import axios_auth from '@/axios_auth';
import EventBus from '@/EventBus'

export default {
  name: 'Login',
  data() {
    return {
      valid: false,
      e1: false,
      user_data: {
        username: '',
        password: '',
        system: 'parcel-receive'
      },
      passwordRules: [
        (v) => !!v || 'กรุณากรอกรหัสผ่าน',
      ],
      usernameRules: [
        (v) => !!v || 'กรุณากรอกชื่อผู้ใช้งาน',
      ],
      error: {
        status: 1,
        error_code: '401',
        msg: ''
      }
    }

  },
  mounted() {
    console.log(Date.now())
    let localItem = this.getLocalItem();
    if (localItem) {
      if (localItem.availableUntil) {
        if (this.$moment().diff(localItem.availableUntil, 'second') < 0) {
          return this.$router.replace({name: 'project'})
        }
      }
    }
  },
  methods: {
    async loginUser() {
      try {
        axios_auth.post('/Authentication', JSON.stringify(this.user_data))
          .then(res => {
            if (res.data.status === '1') {
              //set user token to localStorage
              let auth_data = {
                'refreshToken': res.data.refreshToken,
                'token': res.data.jwt,
                'user_id': this.user_data.username.toLowerCase()
              }
              localStorage.setItem('parcel', JSON.stringify(auth_data))
            }

          }).then(() => {
          this.refreshToken().then((res) => {
            let auth_data = {
              'refreshToken': res.refreshToken,
              'token': res.jwt,
              'user_id': this.user_data.username.toLowerCase(),
              'availableUntil': res.availableUntil
            };
            localStorage.setItem('parcel', JSON.stringify(auth_data));

            EventBus.$emit('setToken', {token: res.jwt});

            this.$router.replace({name: 'project'})
          })
        })
          .catch(err => {
            if (err.response) {
              this.error.status = err.response.data.status;
              this.error.error_code = err.response.status;
              if (err.response.status === 401) {
                this.error.msg = 'ชื่อผู้ใช้งาน หรือ รหัสผ่านไม่ถูกต้อง'
              } else {
                this.error.msg = err.response.data.msg
              }

              console.log(this.error)
            }
          })
      } catch (err2) {
        console.log(err2.message)
      }
    }
  }
}
</script>

<style scoped>
.loginOverlay {
  background: #fff;
}

.card-border {
  border-radius: 10px;
}

.v-card__text {
  padding: 16px;
}
</style>
